import {Mapper} from '@s-ui/domain'

export class FromRawVersionsToVehicleInsightsValueObjectMapper extends Mapper {
  constructor({config, vehicleInsightsValueObjectFactory}) {
    super()
    this._COMPARE_LESS_POWERFUL_AND_CHEAPEST = (v1, v2) => {
      return v1.hp === v2.hp ? v1.manufacturerPrice - v2.manufacturerPrice : v1.hp - v2.hp
    }
    this._COMPARE_MORE_POWERFUL_AND_EXPENSIVE = (v1, v2) => {
      return v1.hp === v2.hp ? v2.manufacturerPrice - v1.manufacturerPrice : v2.hp - v1.hp
    }
    this._config = config
    this._vehicleInsightsValueObjectFactory = vehicleInsightsValueObjectFactory
  }

  _getTitleFromVersions(versions) {
    if (!versions) return
    const [firstItem] = versions
    return `${firstItem?.make} ${firstItem?.model}`
  }

  _getFuelTypes(versions) {
    return Array.from(
      new Set(
        versions.map(({fuelType}) => {
          return fuelType
        })
      )
    )
  }

  _getCountDoorsOptions(versions) {
    return new Set(
      versions.map(({doors}) => {
        return doors
      })
    ).size
  }

  _getFullVersion(versions) {
    versions.sort(this._COMPARE_MORE_POWERFUL_AND_EXPENSIVE)
    const [firstItem] = versions
    return firstItem
  }

  _getBasicVersion(versions) {
    versions.sort(this._COMPARE_LESS_POWERFUL_AND_CHEAPEST)
    const [firstItem] = versions
    return firstItem
  }

  _getMinPrice(versions) {
    return versions.reduce((prevPrice, {manufacturerPrice: currentPrice}) => {
      return prevPrice < currentPrice ? prevPrice : currentPrice
    }, Infinity)
  }

  _getMaxPrice(versions) {
    return versions.reduce((prevPrice, {manufacturerPrice: currentPrice}) => {
      return prevPrice > currentPrice ? prevPrice : currentPrice
    }, -Infinity)
  }

  _getVehicleInsights(versions) {
    if (!versions) return
    const minPrice = this._getMinPrice(versions)
    const maxPrice = this._getMaxPrice(versions)
    const basicVersion = this._getBasicVersion([...versions])
    const fullVersion = this._getFullVersion([...versions])
    const {
      acceleration: minAcceleration,
      bodyType,
      fuelType: minFuelType,
      height: minHeight,
      hp: minHp,
      length: minLength,
      trunkCapacityInLiters: minLuggageCapacity,
      make,
      width: minWidth
    } = basicVersion
    const {
      acceleration: maxAcceleration,
      fuelType: maxFuelType,
      height: maxHeight,
      hp: maxHp,
      length: maxLength,
      trunkCapacityInLiters: maxLuggageCapacity,
      width: maxWidth
    } = fullVersion

    const fuelTypes = this._getFuelTypes(versions)
    const countDoorsOptions = this._getCountDoorsOptions(versions)

    return this._vehicleInsightsValueObjectFactory({
      bodyType,
      countDoorsOptions,
      countVersions: versions.length,
      fuelTypes,
      make,
      maxAcceleration,
      maxFuelType,
      maxHeight,
      maxHp,
      maxLength,
      maxLuggageCapacity,
      maxPrice,
      maxWidth,
      minAcceleration,
      minFuelType,
      minHeight,
      minHp,
      minLength,
      minLuggageCapacity,
      minPrice,
      minWidth
    })
  }

  map = ({versions}) => {
    return this._getVehicleInsights(versions)
  }
}
